<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">{{ cafeName }} 카페의 상세정보</div>
                    <div class="tab">
                        <div class="tab_wrap">
                            <div class="t_txt"  @click="moveTab('')">상세정보</div>
                            <div class="t_txt" @click="moveTab('live')">라이브</div>
                            <div class="t_txt" @click="moveTab('endlive')">END 라이브</div>
                            <div class="t_txt"  @click="moveTab('post')">포스트</div>
                            <div class="t_txt"  @click="moveTab('member')">멤버</div>
                            <div class="t_txt active"  @click="moveTab('notice')">공지사항</div>
                            <div class="clear"></div>
                        </div>
                    </div>
                    <cafe-write-component :cafeKey="cafeKey" :cafeType="`noLayout`"></cafe-write-component>
                    <div class="tab_content">
                        <board-list-component :boardType="`cafeNotice`" :cafeKey="cafeKey"></board-list-component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "@/utils/event-bus";
    import BoardListComponent from "@/components/board/BoardListComponent";
    import CafeWriteComponent from "@/components/justcafe/CafeWriteComponent";

    export default {
        name: 'CafeDetailNotice',
        components: {
            CafeWriteComponent,
            BoardListComponent,
        },
        mixins: [  ],
        data() {
            return{
                tabIdx: 1,
                cafeKey: Number(this.$route.params.c_idx),
                cafeName:''
            }
        },
        beforeRouteEnter(from,to, next){
            if(to.name === 'CafeNoticeDetail' || to.name === 'CafeConfigDetail'){
                next(vm => {vm.tabIdx = 5})
            }else {
              next()
            }
        },
        mounted() {
            EventBus.$on('CafeDetailSetData',this.setData)
        },
        beforeDestroy() {
            EventBus.$off('CafeDetailSetData')
        },
        watch: {
        },
        created() {
        },
        methods: {
            setData(key,value){
                this[key] = value
            },
            save() {
                EventBus.$emit('writeCafe')
            },
            moveTab(path) {
                let movePath = `/cafe/${this.cafeKey}/${path}`;
                if(path === '') {
                    movePath = `/cafe/${this.cafeKey}`
                }
                if(this.$route.path != movePath) {
                    this.$router.replace(movePath);
                }

            },
            changeTab(num) {
                if(num === this.tabIdx) {
                    return false;
                }
                this.$router.replace(`${this.$route.path}?tabIdx=${num}`);
                this.tabIdx = '';
                this.$nextTick(() => {
                    this.tabIdx = num;
                })
            },
        }
    }
</script>
